import React from 'react';
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { Destination } from 'model';

import { ImageAsset, SVGAsset } from 'res';
import "./styles.css";

export default function TravelPlanWidget(props) {
    const location = props.location ?? "[[location]]";
    const status = props.status ?? "[[status]]";
    const dateRange = props.dateRange ?? "[[mmm dd - mmm dd]]";

    let flag = props.flagIcon ?? "";

    if(location.indexOf(",") === -1 && flag.length === 0) {
        const destinationFlag = Destination.getFlagByName(location);
        flag = destinationFlag.length === 0 ? "WhiteFlagIcon" : destinationFlag;
    }
    else if(flag.length === 0) { flag = "WhiteFlagIcon"; }

    return (
        <div className="travel-plan-widget flex-container flex-horizontal align-center-container clickable">
            <DisabledPrompt>
                <div className="set-width">
                    <ImageAsset id={ flag } className="icon left-inline-icon" />
                </div>
                <div className="flex-width">
                    <p><span>{location}</span></p>
                    <p><span className="sub-text">{status}</span></p>
                </div>
                <div className="set-width">
                    {dateRange}
                </div>
                <div className="set-width">
                    <SVGAsset id="RightChevronIcon" className="chevron-icon right-inline-icon" />
                </div>
            </DisabledPrompt>
        </div>
    );
}
